
import * as Sentry from '@sentry/vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Hub } from 'aws-amplify';
import { CognitoUserInterface } from '@aws-amplify/ui-components';
import ImpersonateBar from '@/components/user-management/ImpersonateBar.vue';

@Component({
  components: {
    ImpersonateBar,
  },
})
export default class App extends Vue {
  created() {
    this.$store.dispatch('auth/getUser');
    Hub.listen('auth', this.onAuth);
  }

  async onAuth(data: any) {
    const { payload } = data;
    if (payload.event === 'signIn') {
      await this.$store.dispatch('auth/getUser');

      // Open loader when signIn event is active
      const loading = this.$buefy.loading.open({});

      // Remember the device if the option was set during login
      this.rememberDevice(payload.data);

      // Get the profile
      await this.$store.dispatch('profile/getProfile');

      // Close loader when profile is available and redirect to home
      loading.close();
      const redirect: any = this.$route.query.redirect || '/dashboard';
      await this.$router.push(redirect);
    }
    if (payload.event === 'signOut') {
      await this.$store.dispatch('resetState');
      await this.$router.push('/auth');
    }
  }

  rememberDevice(user: CognitoUserInterface) {
    if (!this.$store.state.auth.rememberDevice) {
      return;
    }

    user.getCachedDeviceKeyAndPassword();
    user.setDeviceStatusRemembered({
      onFailure(err: any) {
        Sentry.captureException(err);
      },
    });
  }

  @Watch('$i18n.locale', { immediate: true })
  onLocaleChange(newVal?: string): void {
    if (newVal) {
      document.documentElement.setAttribute('lang', newVal);
    }
  }
}
